"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InlineReadOnlyDiv = function InlineReadOnlyDiv(props) {
  var element = props.value,
      className = props.className;

  // const support = () => {
  //   if (!window.DOMParser) return false;
  //   var parser = new DOMParser();
  //   try {
  //     parser.parseFromString("x", "text/html");
  //   } catch (err) {
  //     return false;
  //   }
  //   return true;
  // };

  // const stringToHTML = (str) => {
  //   const isSupported = support();
  //   if (isSupported) {
  //     const parser = new DOMParser();
  //     const doc = parser.parseFromString(str, "text/html");
  //     const req = doc.body.childNodes[0];
  //     return req;
  //   }

  //   // Otherwise, fallback to old-school method
  //   var dom = document.createElement("div");
  //   dom.innerHTML = str;
  //   return dom;
  // };

  // const target = stringToHTML(element);

  // if (!target) {
  //   return null;
  // }
  // const MyElement = React.createElement(
  //   target.nodeName.toLowerCase(),
  //   { dangerouslySetInnerHTML: { __html: target.innerHTML } },
  //   null
  // );

  return _react2.default.createElement("div", { className: className, dangerouslySetInnerHTML: { __html: element } });
};

exports.default = InlineReadOnlyDiv;